///
/// 타입 정의
///
// 메세지 타입
type Message = string;
// 메세지 맵 타입
type MessageMap = Record<string, Message>;

///
/// 대화상자 메세지 정의
///
const DialogMessage: MessageMap = {
  ConfirmChangeDataOnDCMView: "Data will be changed \nDo you want to continue?",
  ConfirmUnloadDataOnDCMView:
    "Data will be unloaded \nDo you want to continue?",
  ConfirmUnloadAllDataOnDCMView:
    "All data will be unloaded \nDo you want to continue?",
  ConfirmRemoveDataOnDCMView: "Data will be removed \nDo you want to continue?",
  ConfirmRemoveAllDataOnDCMView:
    "All data will be removed \nDo you want to continue?"
};

export default DialogMessage;
